export class Continent {
	public constructor(public readonly identity: string, public readonly name: string) {}
}
